import { computed, reactive, Ref } from 'vue';

import { getFormattedCurrency } from '@/helpers/number';
import { getNextPackagePrice, getPackagePrice } from '@/pages/payment/helpers/package/package';
import { PaymentStatePackagePremium } from '@/pages/payment/store/payment-state';
import { getTextPageModal } from '@/pages/text-page/helpers/text-page/text-page';
import { sendClarityEvent } from '@/services/clarity/clarity';
import { useSplitAuthorizationFee } from '@/services/growth-book/hooks/use-split-authorization-fee/use-split-authorization-fee';
import { getState } from '@/store/store-helper';

type UseSelfArg = {
  packageSelected: Ref<PaymentStatePackagePremium>;
};

export function useSelf(arg: UseSelfArg) {
  // Ref -----------------------------------------------------------------------
  const textPageModal = getTextPageModal();

  // Hook ----------------------------------------------------------------------
  const splitAuthorizationFee = useSplitAuthorizationFee();

  // Computed ------------------------------------------------------------------

  const hasCardToken = computed(() => {
    return getState().payment.paymentCards.length > 0;
  });

  const packageSelectedPriceNextFormatted = computed(() => {
    if (arg.packageSelected.value!) {
      const packageNextPrice = getNextPackagePrice(arg.packageSelected.value!);
      return getFormattedCurrency(
        packageNextPrice?.totalAmount ?? 0,
        packageNextPrice?.currency ?? 'USD',
      );
    }
    return '';
  });

  const packageSelectedPriceFormatted = computed(() => {
    const packagePrice = getPackagePrice(arg.packageSelected.value!);
    return getFormattedCurrency(packagePrice?.totalAmount ?? 0, packagePrice?.currency ?? 'USD');
  });

  // Method --------------------------------------------------------------------
  function getPriceDiscountFixed() {
    const price = 0n;

    return price;
  }

  async function init() {
    await splitAuthorizationFee.init();
  }

  function mount() {
    sendClarityEvent('paywall-prem');
  }

  return reactive({
    textPageModal,
    splitAuthorizationFee,
    hasCardToken,
    packageSelectedPriceNextFormatted,
    packageSelectedPriceFormatted,
    getPriceDiscountFixed,
    init,
    mount,
  });
}
